import React from 'react';
import { connect } from 'react-redux';
import { createActions } from '../../../store';
import SliderListItem from '../../../../../list-items/SliderListItem';
import { previewHistoryBatch } from '../../../store/extensions';

const VisualizerXPositionListItem = (props) => {
    const { visualizerPositionX, updateVisualizerSettings, maxXPosition } = props;
    
    const onPositionChange = (value) => {
        previewHistoryBatch.start();
        updateVisualizerSettings({ position: { x: value } });
    };
    
    return (
        <SliderListItem
            title='X Position'
            value={visualizerPositionX}
            displayMultiplier={1}
            min={-maxXPosition}
            max={maxXPosition}
            step={1}
            onValueChange={onPositionChange}
        />
    );
};

const mapStateToProps = (state) => {
    const { x: visualizerPositionX } = state.createPreview.present.videoSettings.visualizer.position;
    const { maxXPosition } = state.create.maxValues;

    return { 
        visualizerPositionX,
        maxXPosition
    };
}

const mapDispatchToProps = (dispatch) => {
    const updateVisualizerSettings = (properties) => dispatch(createActions.updateVisualizerSettings(properties));
    return { updateVisualizerSettings }
}

export default connect(mapStateToProps, mapDispatchToProps)(VisualizerXPositionListItem);